import {
  ISelectOption,
  IFilterProfileLite,
  IState,
  IRegion,
  IOperator
} from '$/types'
import { UNSAVED_PROFILE_NAME } from 'app/layout/Navbar/Filters/FilterModal/constants'

/**
 * Find unsaved profile from profiles list.
 * NOTE: If input parameter are of type `IFilterProfile[]` instead of
 *       `IFilterProfileLite[]`, then return type can be casted to
 *       `IFilterProfile`
 *
 * @param profiles Array of `IFilterProfileLite` or `IFilterProfile`
 * @returns `undefined` or `IFilterProfileLite` or `IFilterProfile` depending on input
 */
export const getUnsavedProfile = (
  profiles: IFilterProfileLite[]
): IFilterProfileLite | undefined => {
  return profiles.find(
    (p) => p.name.toLowerCase() === UNSAVED_PROFILE_NAME.toLowerCase()
  )
}

export const getDefaultProfileId = (
  profiles: IFilterProfileLite[]
): string | null => profiles.filter((p) => p.isDefault)[0]?.id

/**
 * Map IOperator, IState, or IRegion (OSR) array to ISelectOption array.
 *
 * @param OSRArr Array of IOperator, IState, or IRegion
 * @returns ISelectOption array (may or may not be empty)
 */
export const mapOSRToSelectOption = (
  OSRArr?: IState[] | IRegion[] | IOperator[]
): ISelectOption[] => {
  return (
    OSRArr?.map((ele: IState | IRegion | IOperator) => ({
      label: ele.name,
      value: ele.code
    })) ?? []
  )
}
